<template>
  <div :class="$style.container">
    <p :class="$style.price">
      {{ medianPriceData[propertyType].price }} CHF/<span>m<sup>2</sup></span>
    </p>
    <p :class="$style.priceRange">
      {{
        t('averageMarketPrice.fromTo', [
          medianPriceData[propertyType].range.min,
          medianPriceData[propertyType].range.max,
        ])
      }}
      CHF/<span>m<sup>2</sup></span>
    </p>
    <p :class="$style.dateStyle">
      {{ t('averageMarketPrice.dateFrom', [medianPriceData[propertyType].date]) }}
    </p>
    <HgLink
      name="priceCardRedirect"
      :class="$style.link"
      :disabled="isLoading"
      :href="link"
      @click="trackCurrentPriceBoxToValuationEntry"
    >
      {{ t('averageMarketPrice.averageMarketPriceLink.' + propertyType) }}
    </HgLink>
  </div>
</template>
<script setup lang="ts">
import { HgLink } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { type MedianPriceData } from '@/components/median-price/adaptData';
import useMapStore from '@/stores/useMapStore';
import { trackCurrentPriceBoxToValuationEntry } from '@/tracking';
import { getValuationFunnelUrl } from '@/utils/functions';

interface Props {
  medianPriceData: MedianPriceData;
}

const { medianPriceData } = defineProps<Props>();

const { t } = useI18n();
const mapStore = useMapStore();
const { propertyType, isLoading } = storeToRefs(mapStore);

const link = computed<string>(() => getValuationFunnelUrl(t));
</script>

<style lang="scss" module>
@use '@/styles/variables' as *;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $color-grey-100;
}

.price {
  margin-top: 0;
  margin-bottom: 0;

  @include body-1;
}

.priceRange {
  margin-top: 0;
  margin-bottom: 0;

  @include body-3;
}

.dateStyle {
  display: inline-block;
  margin-top: 0;
  margin-bottom: $space-150;

  @include caption;
}

.link {
  @include body-2-bold;
}
</style>
